import React from 'react';

// Types
import { GifType } from '../../types';

// Components
import { WpGif } from '../../';

// Styles
import './GifList.scss';

type GifListProps = {
  onSelect?: Function;
  gifs: GifType[];
};
const GifList = ({ gifs, onSelect }: GifListProps) => {
  const handleClick = gif => {
    if (onSelect) onSelect(gif);
  };
  const baseClassName = 'GifList';

  const leftColumn = gifs.filter((_, index) => {
    return index % 2 === 0;
  });

  const rightColumn = gifs.filter((_, index) => {
    return index % 2 !== 0;
  });

  return (
    <div className={baseClassName}>
      <div className={`${baseClassName}__column`}>
        {leftColumn.map(gif => {
          return (
            <div key={gif.id} className={`${baseClassName}__gif-item`} onClick={() => handleClick(gif)}>
              <WpGif url={gif.images.fixed_width.url} />
            </div>
          );
        })}
      </div>
      <div className={`${baseClassName}__column`}>
        {rightColumn.map(gif => {
          return (
            <div key={gif.id} className={`${baseClassName}__gif-item`} onClick={() => handleClick(gif)}>
              <WpGif url={gif.images.fixed_width.url} />
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default GifList;
